<template>
  <router-view />
</template>

<script>
import store, { name } from '@/modules/scholarship/store';

export default {
  name: 'ScholarshipWrapper',
  data: () => ({
    page: {
      title: 'Beca',
      icon: 'fas fa-user-tie',
      routes: ['Beca'],
    },
  }),
  provide() {
    return {
      page: this.page,
    };
  },
  created() {
    this.$store.registerModule(name, store);
  },
  destroyed() {
    this.$store.unregisterModule(name);
  },
};
</script>
